import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import PaymentServiceTemplatesTableRow from '../PaymentServiceTemplatesTableRow'

const PaymentServiceTemplatesTable = ({
  paymentServiceTemplates = [],
  refresh = () => {},
}) => {
  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhum serviço encontrado" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="25%" align="left">
                Nome
              </TableCell>
              <TableCell width="20%" align="center">
                Valor sugerido
              </TableCell>
              <TableCell width="20%" align="center">
                Prazo padrão
              </TableCell>
              <TableCell width="15%" align="center">
                Status
              </TableCell>
              <TableCell width="15%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentServiceTemplates.map((paymentServiceTemplate) => (
              <PaymentServiceTemplatesTableRow
                key={paymentServiceTemplate.id}
                paymentServiceTemplate={paymentServiceTemplate}
                refresh={refresh}
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

PaymentServiceTemplatesTable.propTypes = {
  paymentServiceTemplates: PropTypes.arrayOf(Object),
  refresh: PropTypes.func,
}

export default PaymentServiceTemplatesTable
